import { SELECIONAR_PERFIS } from '../types'

export default function limparPerfis () {
  return {
    type: SELECIONAR_PERFIS,
    payload: []
  }
}
